<template>
	<fieldset class="guestrooms_fieldset">
		<legend>{{ language.guestPerRoom }}</legend>

		<div class="label" id="bookingform__guests__label">{{ language.guestPerRoom }}</div>

		<div class="form-row">

			<div class="form-field">
				<label for="guests" class="counter_text">
					{{ language.people_bar }}
				</label>
				<div class="number_counter" data-max="2">
					<transition name="fade">
						<span class="minus" @click="setGuests(-1)" v-if="guestsChangeable[0]"></span>
						<span class="minus inaktive" v-if="!guestsChangeable[0]"></span>
					</transition>
					<input type="text" id="guests" name="guests" max="11" ref="guests" v-model="guests" @keyup="changeGuests">
					<transition name="fade">
						<span class="plus" @click="setGuests(1)" v-if="guestsChangeable[1]"></span>
						<span class="plus inaktive" v-if="!guestsChangeable[1]"></span>
					</transition>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
export default {
	name: 'Guests',

	data: function(){
		return {
			dropDownOpen: false
		}
	},
	mounted: function (){
		this.guestsChangeable
	},
	computed: {
		editMode: function() {
			return this.$store.state.editMode
		},
		language: function() {
			return this.$store.state.language
		},

		citizenm: function(){
			return window.citizenm ? window.citizenm : { helpers: { show: function(){return}}}
		},

		shortHandText: function(){
			let text = this.guests + ' ' + (this.guests > 1 ? this.language.adults : this.language.adult)
			return text + ' - ' + this.rooms +  ' ' + (this.rooms > 1 ? this.language.rooms : this.language.room)
		},
		guestsChangeable: {
			set(){
				return this.get
			},
			get(){
				const stat = [true, true]

				if (this.$store.state.guests == 1) {
					stat[0] = false
				}
				if (this.$store.state.guests >= this.$store.state.guestsMax) {
					stat[1] = false
				}

				return stat
			}
		},
		guests: {
			set(value) {
				this.$store.commit('setGuests', Math.min(parseInt(value), this.$store.state.guestsMax))
				this.$refs.guests.value = Math.min(parseInt(value), this.$store.state.guestsMax)
			},
			get() {
				return this.$store.state.guests
			}
		}
	},

	methods: {

		enterEditMode() {
			this.$emit('edit')
		},

		onFocus() {
			this.$emit('focus')
		},

		toggleDropdown() {
			if(this.dropDownOpen) return this.hideDropdown()
			return this.openDropdown()
		},
		openDropdown() {
			this.dropDownOpen = true
			this.$emit('opened')
		},
		hideDropdown() {
			this.dropDownOpen = false
			this.$emit('closed')
		},

		close: function(){
			return this.hideDropdown()
		},
		setGuests: function (diff) {
			let newGuests = this.$store.state.guests + parseInt(diff)
			if (newGuests > this.$store.state.guestsMax) {
				newGuests = this.$store.state.guestsMax
			}
			this.$store.commit('setGuests', newGuests)
			this.guestsChangeable
		},

		addGuest: function () {

		},
		removeGuest: function() {

		},

		changeGuests: function(e){
			switch(e.key) {
				case 'ArrowUp':
				case 'ArrowRight':
					if(this.guestsChangeable[1]) this.setGuests(1)
					break
				case 'ArrowDown':
				case 'ArrowLeft':
					if(this.guestsChangeable[0]) this.setGuests(-1)
					break
				default:
					break
			}
		},
	}
}
</script>